import {DATE_FORMAT, ScarInjectionInformedConsentForm} from "../../common";
import {Button, Checkbox, Col, DatePicker, Divider, Input, InputNumber, Row} from "antd";
import React, { useRef } from "react";
import { formatDateStrInput } from "../common";
import "./index.css";
import handleAxios, {
    PostoperativePrecautionsForScarSurgeryFileDownLoad,
    ScarInjectionInformedConsentFileDownLoad
} from "../../../../Http/request";
import {generateDateStr} from "../../Details/common";
import {SUBMIT_TYPE} from "../../../../Http/common";

interface P {
  defaultValue: ScarInjectionInformedConsentForm;
  newValue?: ScarInjectionInformedConsentForm;
  fatherChange(newValue: ScarInjectionInformedConsentForm): void;
  saveDraft(newValue: ScarInjectionInformedConsentForm | undefined, saveType: SUBMIT_TYPE): void
}

/**
 * 瘢痕注射知情同意书
 */
export default function ({ defaultValue, newValue, fatherChange, saveDraft }: P) {
  // 当前模块的值
  const moduleValue = useRef<ScarInjectionInformedConsentForm | undefined>(defaultValue);

  /**
   * 更新模块中的某个值
   */
  const partChange = (newValue: Partial<ScarInjectionInformedConsentForm>): void => {
    let newModuleValue: ScarInjectionInformedConsentForm;
    if (moduleValue.current === undefined) {
      newModuleValue = { ...defaultValue };
      moduleValue.current = newModuleValue;
    }
    newModuleValue = {
      ...moduleValue.current,
      ...newValue,
    };
    moduleValue.current = newModuleValue;
    fatherChange(newModuleValue);
  };

  return (
    <>
      <Row
        justify="start"
        align="middle"
        className="custom-line-row"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <Col span={2}>姓名</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.name}
            onChange={(e) => {
              partChange({ name: e.target.value });
            }}
          />
        </Col>

        <Col span={2}>性别</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.gender}
            onChange={(e) => {
              partChange({ gender: e.target.value });
            }}
          />
        </Col>

        <Col span={2}>年龄</Col>
        <Col span={2}>
            <InputNumber
                changeOnWheel
                style={{
                    width: "100%"
                }}
                defaultValue={defaultValue.age}
                onChange={(e:number | null) => {
                    partChange({age: e === null ? undefined : e})
                }}
                addonAfter={"岁"}
            />
        </Col>
        <Col span={2}>身份证号</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.IDNumber}
            onChange={(e) => {
              partChange({ IDNumber: e.target.value });
            }}
          />
        </Col>
      </Row>
        <Row  justify="start" align="middle" className="custom-line-row">
            <Col span={2}>诊断:</Col>
            <Col span={4}>
                <Input
                    defaultValue={defaultValue.diagnosis}
                    onChange={(e) => {
                        partChange({ diagnosis: e.target.value });
                    }}  />
            </Col>
            <Col span={2}>
                注射部位
            </Col>
            <Col span={4}>
                <Input
                    defaultValue={defaultValue.injectionLocation}
                    onChange={(e) => {
                        partChange({injectionLocation: e.target.value})
                    }}
                />
            </Col>
            <Col span={8}>
                <Checkbox
                    defaultChecked={defaultValue?.injectionPlanCheck0}
                    onChange={v => partChange({injectionPlanCheck0: v.target.checked})}
                >
                    局部注射皮质类固醇激素
                </Checkbox>
                <Checkbox
                    defaultChecked={defaultValue?.injectionPlanCheck1}
                    onChange={v => partChange({injectionPlanCheck1: v.target.checked})}
                >
                    局部注射皮质类固醇激素
                </Checkbox>
            </Col>
        </Row>
        <Row  justify="start" align="middle" className="custom-line-row">
        <Col span={2}>签名日期</Col>
        <Col span={4}>
          <DatePicker
            style={{ width: "100%" }}
            showTime={{ format: 'HH:mm' }}
            defaultValue={formatDateStrInput(defaultValue.recordTimeStr, DATE_FORMAT)}
            onChange={(value, dateStr: string | string[]) => {
              if (typeof dateStr === 'string') {
                partChange({ recordTimeStr: dateStr });
              } else {
                partChange({ recordTimeStr: dateStr[0] });
              }
            }}
          />
        </Col>
      </Row>
        <Row
            justify="start"
            align="middle"
            style={{
                marginTop: "9px",
                marginBottom: "9px"
            }}
        >
            <Divider>下载&保存</Divider>
            <Col span={3}>
                <Button
                    type={'link'}
                    onClick={() => {
                        if (moduleValue.current == undefined) {
                            return
                        }
                        ScarInjectionInformedConsentFileDownLoad(moduleValue.current);
                        saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY)
                    }}
                >
                    下载疤痕注射同意书
                </Button>
            </Col>
            <Col span={3}>
                <Button
                    type={"primary"}
                    onClick={() => saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY)}>
                    保存疤痕注射同意书草稿
                </Button>
            </Col>
        </Row>
    </>
  );
}